doWork